import { useLayoutEffect } from "react";

/**
 * Scrolls to the top whenever `key` changes.
 * Uses instant scrolling so the new page never starts at the old scroll depth.
 */
export function useScrollToTop(key: unknown) {
  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" as ScrollBehavior });
    // Fallback for older browsers
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [key]);
}

